module.exports = __webpack_public_path__ + "static/img/training_system_hy_s2.ba51fb3f.png";